import { ReportTemplate } from '../ReportTemplate.model';
import { DeviceDataValue } from './DeviceDataValue.model';

export enum OrderStatusEnum {
  OPEN = 'Open',
  PENDING = 'Pending',
  COMPLETE = 'Complete',
  CLOSED = 'Closed',
  EXPIRED = 'Expired',
  REVIEW = 'Review',
  CANCELLED = 'Cancelled',
}

export interface SiteData {
  SiteId: DeviceDataValue<string>;
  SiteName: DeviceDataValue<string>;
}

interface BaseOrderFields {
  Priority: number;
  OrderId: string;
  Status: OrderStatusEnum;
  OrderStatusDatetime: string;
  OrderType: ReportTemplate;
  SiteId: string;
  SiteName: string;
  ReportFile?: string;
  IsSharedWithProvider?: boolean;
  IsSavedToChart?: boolean;
  ReportDatetime?: string;
}

export type OrderData = {
  [K in keyof BaseOrderFields]: DeviceDataValue<BaseOrderFields[K]>;
};

export type OrderSubmissionData = Partial<BaseOrderFields>;

export type OrderTaskId = keyof Pick<
  OrderData,
  'IsSharedWithProvider' | 'IsSavedToChart'
>;
